import type { TFraternityJoinParams } from '@/src/general/constants/routes'
import { useRoutes } from '@/src/general/utils/routes'

import type { TJoinDestination } from '../../models/joinSteps.types'

type TGetCommunityJoinRouteParams = TIdSlug & TFraternityJoinParams

type TJoinRouteDestination = Exclude<TJoinDestination, 'community'>

export const useGetCommunityJoinRoute = () => {
  const { routes } = useRoutes()

  return (destination: TJoinRouteDestination, params: TGetCommunityJoinRouteParams) => {
    switch (destination) {
      case 'date':
        return routes.communityJoinDate(params)
      case 'push':
        return routes.communityJoinNotifications(params)
      case 'email':
        return routes.communityJoinMail(params)
      case 'congrats':
        return routes.communityJoinCongrats(params)
      case 'ready':
        return routes.communityJoinReady(params)
      case 'presentation':
        return routes.communityJoinPresentation(params)
      case 'fraternity':
        return routes.communityJoinFraternity(params)
      case 'gender':
        return routes.communityJoinGender(params)
      case 'place':
        return routes.communityJoinPlace(params)
      case 'lead':
        return routes.communityJoinLead(params)
      case 'recap':
        return routes.communityJoinRecap(params)
      default: {
        const exhaustiveCheck: never = destination
        return exhaustiveCheck
      }
    }
  }
}
